import { useCallback, useEffect, useState } from 'react';
import { Navigate, Route, Routes, useLocation, useNavigate } from 'react-router-dom';

import * as routing from '../../../constants/Routing';
import { Project } from '../../../domain/project/Project';
import ProjectAnalyticsPlannerAllStops from './ProjectAnalyticsPlannerAllStops';
import ProjectAnalyticsPlannerCanceledStops from './ProjectAnalyticsPlannerCanceledStops';
import ProjectAnalyticsPlannerCancellationReasons from './ProjectAnalyticsPlannerCancellationReasons';
import ProjectAnalyticsPlannerCompletedStops from './ProjectAnalyticsPlannerCompletedStops';
import ProjectAnalyticsPlannerDeliveryTime from './ProjectAnalyticsPlannerDeliveryTime';
import ProjectAnalyticsPlannerIncompleteStops from './ProjectAnalyticsPlannerIncompleteStops';
import ProjectAnalyticsPlannerPlans from './ProjectAnalyticsPlannerPlans';
import ProjectAnalyticsPlannerProofOfDelivery from './ProjectAnalyticsPlannerProofOfDelivery';

interface ProjectAnalyticsPlannerProps {
  project: Project;
}

const ProjectAnalyticsPlanner = ({ project }: ProjectAnalyticsPlannerProps) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [currentView, setCurrentView] = useState<string>(``);

  const setLocationView = useCallback(
    (view: string) => {
      if (view !== currentView) {
        setCurrentView(view);
        navigate(`${view.replace(`:projectId`, `${project?.id}`)}`);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [currentView, project?.id]
  );

  useEffect(() => {
    if (!!location && location.pathname !== ``) {
      if (
        location.pathname.indexOf(routing.PROJECT_ANALYTICS.PLANNER.PLANS.replace(`/h/:projectId`, ``)) === -1 &&
        location.pathname.indexOf(routing.PROJECT_ANALYTICS.PLANNER.ALL_STOPS.replace(`/h/:projectId`, ``)) === -1 &&
        location.pathname.indexOf(routing.PROJECT_ANALYTICS.PLANNER.COMPLETED_STOPS.replace(`/h/:projectId`, ``)) ===
          -1 &&
        location.pathname.indexOf(routing.PROJECT_ANALYTICS.PLANNER.INCOMPLETE_STOPS.replace(`/h/:projectId`, ``)) ===
          -1 &&
        location.pathname.indexOf(routing.PROJECT_ANALYTICS.PLANNER.CANCELED_STOPS.replace(`/h/:projectId`, ``)) ===
          -1 &&
        location.pathname.indexOf(routing.PROJECT_ANALYTICS.PLANNER.DELIVERY_TIME.replace(`/h/:projectId`, ``)) ===
          -1 &&
        location.pathname.indexOf(routing.PROJECT_ANALYTICS.PLANNER.PROOF_OF_DELIVERY.replace(`/h/:projectId`, ``)) ===
          -1 &&
        location.pathname.indexOf(
          routing.PROJECT_ANALYTICS.PLANNER.CANCELLATION_REASONS.replace(`/h/:projectId`, ``)
        ) === -1
        // location.pathname.indexOf(
        //   routing.PROJECT_ANALYTICS.PLANNER.STOPS_PER_ZONE.replace(`/h/:projectId`, ``)
        // ) === -1 &&
      ) {
        setLocationView(routing.PROJECT_ANALYTICS.PLANNER.PLANS);
      }
    }
  }, [location, setLocationView]);

  return (
    <Routes>
      <Route path="/" element={<Navigate to="/plans" />} />

      <Route path="/plans" element={<ProjectAnalyticsPlannerPlans />} />
      <Route path="/stops-status" element={<ProjectAnalyticsPlannerAllStops />} />
      <Route path="/completed-stops" element={<ProjectAnalyticsPlannerCompletedStops />} />
      <Route path="/incomplete-stops" element={<ProjectAnalyticsPlannerIncompleteStops />} />
      <Route path="/canceled-stops" element={<ProjectAnalyticsPlannerCanceledStops />} />
      <Route path="/delivery-schedule" element={<ProjectAnalyticsPlannerDeliveryTime />} />
      <Route path="/proof-of-delivery" element={<ProjectAnalyticsPlannerProofOfDelivery />} />
      <Route path="/cancellation-reasons" element={<ProjectAnalyticsPlannerCancellationReasons />} />
      {/* <Route path="/stops-per-zone" element={<ProjectAnalyticsPlannerStopsPerZone />} /> */}

      <Route
        path="*"
        element={<Navigate to={`${routing.PROJECT_ANALYTICS.PLANNER.PLANS.replace(`:projectId`, project.id)}`} />}
      />
    </Routes>
  );
};

export default ProjectAnalyticsPlanner;
